<template>
  <component :is="tag" class="sp-stepper-header">
    <slot name="preamble" />

    <div class="sp-stepper-header__items" :class="classModifiers">
      <slot />
    </div>
  </component>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "#ce/composables/useBreakpoints";

defineProps({
  tag: {
    type: String,
    default: "div",
  },
});

const { gtModifiers } = useBreakpoints();
const classModifiers = computed(() => [...gtModifiers.value]);
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-stepper-header {
  display: flex;
  flex-direction: column;
  background: var(--sp-comp-stepper-header-background, transparent);
  margin: var(--sp-comp-stepper-header-margin, 0);
  padding: var(--sp-comp-stepper-header-padding, 0);
  gap: var(--sp-comp-stepper-header-gap, var(--sp-ref-scale-20, 1.25rem));
  overflow: hidden;
}

.sp-stepper-header__items {
  --header-stepper-items-gap: var(--sp-comp-stepper-header-items-gap, var(--sp-ref-scale-16));
  display: flex;
  justify-content: center;
  position: relative;
  gap: var(--header-stepper-items-gap);

  &.--gt-sm-screen {
    --header-stepper-items-gap: var(--sp-comp-stepper-header-items-gap-gt-sm, 5rem);
  }
}
</style>
